import { styled, Typography } from "@mui/material";

import { usePagination } from "hooks/filterHooks";
import {
  useFilteredByStringLayerSets,
  useFilteredLayerSets,
  useLayerSets,
  useUrlSelectedLayerSet,
  useSortedLayerSets,
} from "hooks/layerSetHooks";

import { PaddedPaper } from "components/surfaces/PaddedPaper";
import { LayerSetItem } from "./LayerSetItem";
import { LayerSetPagination } from "./LayerSetPagination";
import { LayerSetDialog } from "./dialog/LayerSetDialog";
import { Suspense } from "react";
import { useTranslation } from "react-i18next";

export default function LayerSetSection() {
  const { data: layerSets } = useLayerSets();
  const { page, limit, paginate, updatePage } = usePagination();
  const { t } = useTranslation();
  const filteredLayerSets = useFilteredLayerSets(layerSets || []);
  const filteredByString = useFilteredByStringLayerSets(filteredLayerSets);
  const sortedLayerSets = useSortedLayerSets(filteredByString);
  const paginatedLayerSets = paginate(sortedLayerSets);

  const { urlLayerSetId, selectLayerSet, deselectLayerSet } =
    useUrlSelectedLayerSet();

  return (
    <>
      {urlLayerSetId > 0 && (
        <Suspense>
          <LayerSetDialog
            layerSetId={urlLayerSetId}
            deselectLayerSet={deselectLayerSet}
            layerSets={layerSets || []}
          />
        </Suspense>
      )}
      <StyledPaddedPaper padding={3} elevation={0} id="layerset-content">
        {paginatedLayerSets.length === 0 && (
          <Typography>{t("label.noResultsFound")}</Typography>
        )}
        {paginatedLayerSets.length > 0 &&
          paginatedLayerSets.map((layerSet, index) => {
            if (index === 0) {
              return (
                <LayerSetItem
                  key={layerSet.id}
                  layerSet={layerSet}
                  selectLayerSet={selectLayerSet}
                  data-tour="step-1"
                />
              );
            }
            return (
              <LayerSetItem
                key={layerSet.id}
                layerSet={layerSet}
                selectLayerSet={selectLayerSet}
              />
            );
          })}
      </StyledPaddedPaper>
      <LayerSetPagination
        totalCount={sortedLayerSets.length}
        page={page}
        limit={limit}
        updatePage={updatePage}
      />
    </>
  );
}

const StyledPaddedPaper = styled(PaddedPaper)`
  overflow: auto;
  display: grid;
  height: 100%;
  column-gap: ${({ theme }) => theme.spacing(4)};
  row-gap: ${({ theme }) => theme.spacing(3)};
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-template-rows: repeat(auto-fill, 450px);
`;
